import styled from "@emotion/styled";
import { GelIcon, GelParagraph } from "@tal-gel/components";
import { getGelTokens } from "@tal-gel/theming";

const StyledMovement = styled.div`
  animation: MoveUpDown 1.5s ease-in-out infinite;
  position: relative;
  left: 0;
  bottom: 0;

  @keyframes MoveUpDown {
    0%,
    100% {
      bottom: 0;
    }
    50% {
      bottom: 16px;
    }
  }
`;

const StyledContainer = styled.div`
  //   border: 1px solid ${getGelTokens().global.themeColorBorderInverse};
  width: fit-content;
  border-radius: ${getGelTokens().global.sizeBaseX2}px;
  padding: ${getGelTokens().global.sizeBaseX4}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ScrollMore = () => {
  return (
    <StyledContainer>
      <StyledMovement>
        <GelIcon
          color={getGelTokens().global.themeColorIconInverse}
          width={getGelTokens().global.sizeBaseX7}
          name="ChevronDown"
          inline
        ></GelIcon>
      </StyledMovement>
      <GelParagraph small textAlign="center" inverse>
        Scroll to learn more
      </GelParagraph>
    </StyledContainer>
  );
};

export default ScrollMore;
